var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRanking3 = function SvgRanking3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.655 6.472H2.517V.33a.33.33 0 0 1 .33-.33h10.482a.33.33 0 0 1 .33.33v6.142h-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F54EB",
    d: "M2.517 0h2.666v5.86H2.517V0zm4.25 0h2.637v5.86H6.768V0zm4.222 0h2.666v5.86H10.99V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95AEFF",
    d: "M.009 11.692a8.075 8.075 0 0 0 12.179 7.187 8.077 8.077 0 0 0 3.968-7.187 8.078 8.078 0 1 0-16.148 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M2.078 11.692a6.008 6.008 0 1 0 12.016 0 6.008 6.008 0 0 0-12.016 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.086 15.89c-1.4 0-2.811-.747-2.811-2.636h1.944a.817.817 0 0 0 .867.88.808.808 0 0 0 .867-.903.874.874 0 0 0-.903-.89h-.26v-1.684h.273a.753.753 0 0 0 .807-.794.773.773 0 0 0-.385-.668.77.77 0 0 0-1.157.668H5.384c0-1.588 1.21-2.55 2.715-2.55 1.565 0 2.716 1.044 2.716 2.5a1.8 1.8 0 0 1-.877 1.649 2.075 2.075 0 0 1 .989 1.838c-.017 1.76-1.348 2.59-2.841 2.59z"
  }))));
};
export default SvgRanking3;